import React from "react";
import classNames from "classnames";

import Styles from "./HomepageV2Animate.module.scss";

type AnimVariant = "fade-up" | "fade-left" | "fade-right" | "scale-up";

interface HomepageV2AnimateProps {
    children: React.ReactNode;
    variant?: AnimVariant;
    delay?: number;
    className?: string;
}

const VARIANT_CLASS: Record<AnimVariant, string> = {
    "fade-up": Styles.fadeUp,
    "fade-left": Styles.fadeLeft,
    "fade-right": Styles.fadeRight,
    "scale-up": Styles.scaleUp
};

/** Content is visible by default (SSR-safe). Scroll-in animation is opt-in via reduced-motion CSS. */
const HomepageV2Animate = ({ children, variant = "fade-up", delay = 0, className }: HomepageV2AnimateProps) => (
    <div
        className={classNames(Styles.animate, VARIANT_CLASS[variant], Styles.visible, className)}
        style={{ transitionDelay: `${delay}ms` }}
    >
        {children}
    </div>
);

export default HomepageV2Animate;
